import React, { useEffect } from "react";
import {
  Loandetailsicon,
  Summaryicon,
  Expensesicon,
} from "../../assets/svgIconsList";
import DrawerComponent from "../../components/DrawerComponent";
import HeaderComponent from "../../components/HeaderComponent";
import CssBaseline from "@mui/material/CssBaseline";
import { Box } from "@mui/system";
import Econsent from "./EConsent/Econsent";
import MyLoanApplication from "./MyLoanApplication/MyLoanApplication";
import DocumentsManager from "./DocumnetManager/DocumentsManager";
import {useLocation, useNavigate} from "react-router-dom";
import HouseIcon from "@mui/icons-material/HomeOutlined";
import { styled } from "@mui/material/styles";
import {
  appendQueryParamToURL,
  mapDispatchToProps,
  mapObjectToState,
  mapStateToProps,
} from "../../helpers";
import { connect } from "react-redux";
import { withSnackbar } from "../../components/Snackbar";
import Loader from "../../components/Loader";
import { useState } from "react";
import DocsManager from "./Docs360/DocsManager";
import { API_URL } from "../../redux/constants";
import { getHeaders } from "../../redux/actions/postActions";
import axios from "axios";
import _ from "lodash";
import { BASE_PATH } from "../../constants";


const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const RENDER_IDLE_FRAME_MS = 40;
const RENDER_IDLE_FRAMES = 3;
const RENDER_SETTLE_TIMEOUT_MS = 15000;

/**
 * Loan Summary mounts every accordion in one go, which keeps the main thread
 * busy well after React has committed. A few consecutive smooth frames mean that
 * work is over, so the loader can stay up until the page is actually usable.
 * Returns a cleanup function.
 */
const waitForRenderToSettle = (onSettled) => {
  let frameId;
  let idleFrames = 0;
  let previousFrameTime = performance.now();
  const timeoutId = setTimeout(() => {
    cancelAnimationFrame(frameId);
    onSettled();
  }, RENDER_SETTLE_TIMEOUT_MS);
  const measureFrame = () => {
    const now = performance.now();
    idleFrames =
      now - previousFrameTime <= RENDER_IDLE_FRAME_MS ? idleFrames + 1 : 0;
    previousFrameTime = now;
    if (idleFrames >= RENDER_IDLE_FRAMES) {
      clearTimeout(timeoutId);
      onSettled();
      return;
    }
    frameId = requestAnimationFrame(measureFrame);
  };
  frameId = requestAnimationFrame(measureFrame);
  return () => {
    clearTimeout(timeoutId);
    cancelAnimationFrame(frameId);
  };
};

const LoanDashboard = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  let appId = localStorage.getItem("appId");
  const [open, setOpen] = React.useState(false);
  const [isHovered, setIsHovered] = useState(false);
  let localStoragePageIndex = localStorage.getItem("loan-app-dashboard");
  // const [pageIndex, setPageIndex] = React.useState(
  //   localStoragePageIndex ? localStoragePageIndex : 2
  // );
  const urlParams = new URLSearchParams(new URL(window.location.href).search);
  const validPath = urlParams.has('authentication');
  const [pageIndex, setPageIndex] = React.useState(2);
  let [loading, setLoading] = React.useState(!(appId === null));
  const [dataLoaded, setDataLoaded] = useState(appId === null);
  const [docs360Data, setDocs360Data] = useState([]);

  const menuButtons = validPath ? [
    { buttonName: "Home", icon: HouseIcon },
    { buttonName: "My Tasks", icon: Loandetailsicon },
    { buttonName: "Loan Summary", icon: Summaryicon },
    { buttonName: "Doc Depot", icon: Expensesicon },
    { buttonName: "Resources", icon: Expensesicon },
  ] : [
    { buttonName: "Home", icon: HouseIcon },
    { buttonName: "Loan Summary", icon: Summaryicon },
    { buttonName: "Doc Depot", icon: Expensesicon },
    { buttonName: "Resources", icon: Expensesicon },
  ]

  useEffect(() => {
    fetchHSPAndPreapprovalApiData();
    if (!appId) {
      const urlWithParams = appendQueryParamToURL(
        process.env.REACT_APP_BASE_URL
      );
      navigate(urlWithParams);
    } else {
    const requiredPath = localStorage.getItem("requiredPath");
    const fullPath = window.location.pathname; // Get the full pathname
    let basePath = BASE_PATH; // Get the base path
    if(fullPath.includes(`${BASE_PATH}app`)) {
      basePath = `${BASE_PATH}app`; // Get the base path with "/app"
    }
    if(fullPath.includes(`${BASE_PATH}dashboard`)) {
      basePath = `${BASE_PATH}dashboard`; // Get the base path with "/dashboard"
    }
    if (requiredPath) {
      navigate(`${basePath}${requiredPath}`);
    } else {
      navigate(basePath);
    }
  }
  }, []);

  useEffect(() => {
    return () => {
      props.resetRedux();
    };
  }, []);

  // useEffect(() => {
  //   const queryParams = new URLSearchParams(location.search);
  //   const token = queryParams.get("token");
  //   const siteid = queryParams.get("siteid");
  //   const eccBpName = queryParams.get("ecc-bpname");

  //   if (token && siteid && eccBpName) {
  //     setPageIndex(2);
  //   } else {
  //     setPageIndex(4);
  //   }
  // }, [location.search]);

  useEffect(() => {
    if (appId !== undefined && appId !== null) {
      props.getLoanData(appId);
    }
  }, [appId]);
  useEffect(() => {
    if (localStorage.getItem("appId") !== null) {
      let convertedState = mapObjectToState(
        props.componentState,
        props.getLoanDataWithIdRes.data
      );
      props.copyStateToRedux(convertedState);
      if (!_.isEmpty(props.getLoanDataWithIdRes)) {
        setDataLoaded(true);
      }
    }
  }, [props?.getLoanDataWithIdRes]);

  useEffect(() => {
    if (!dataLoaded) {
      return undefined;
    }
    return waitForRenderToSettle(() => setLoading(false));
  }, [dataLoaded]);
  const handleDrawerOpen = (index) => {
    setOpen(true);
    setPageIndexFunc(index);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };
  const handleMouseEnter = () => {
    if (!open) setIsHovered(true);
  };
  const handleMouseLeave = () => {
    if (!open) setIsHovered(false);
  };
  const setPageIndexFunc = (index) => {
    setPageIndex(index);
    localStorage.setItem("loan-app-dashboard", index);
  };
  const fetchHSPAndPreapprovalApiData = () => {
    let loanGuid = localStorage.getItem("loanGuid");
    axios
    .get(`${API_URL}/customer-service/api/v1/cx/loans/${loanGuid}/documents`, {
      headers: getHeaders(),
    })
    .then((response) => {
      setDocs360Data(response?.data);
    })
    .catch((error) => {
      console.error("Error in fetching data:", error);
    });
  };
  const page = parseInt(pageIndex, 5);
  const validPathComponents = {
    2: <Econsent />,
    3: <MyLoanApplication />,
    4: <DocumentsManager />,
    5: <DocsManager docs360Data={docs360Data} />,
  };

  const defaultComponents = {
    2: <MyLoanApplication />,
    3: <DocumentsManager />,
    4: <DocsManager docs360Data={docs360Data} />,
  };
  const components = validPath ? validPathComponents : defaultComponents;
  return (
    <div>
      {loading && <Loader />}
      {dataLoaded && (
        <div style={{ visibility: loading ? "hidden" : "visible" }}>
          <Box sx={{ display: "flex" }}>
            <CssBaseline />
            <HeaderComponent
              setOpen={() => setOpen(!open)}
              pageIndex={pageIndex}
            />
            <Box 
        component="nav"
        sx={{ flexShrink: { sm: 0 } }}
            >
            <DrawerComponent
              open={open}
              isSubmitted={true}
              isHovered={isHovered}
              setOpen={() => setOpen(!open)}
              pageIndex={pageIndex}
              sideMenuButtons={menuButtons}
              handleDrawerClose={handleDrawerClose}
              handleDrawerOpen={handleDrawerOpen}
              handleMouseEnter={handleMouseEnter}
              handleMouseLeave={handleMouseLeave}
              navigatePage={navigate}
            />
            </Box>
            <Box
              component="main"
              sx={{ flexGrow: 1, p: 3, marginLeft: { sm: '240px'}, pt: 10
               }}
            >
              {/* <DrawerHeader /> */}
              {components[page]}
            </Box>
          </Box>
        </div>
      )}
    </div>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withSnackbar(LoanDashboard));
